import { render, staticRenderFns } from "./SecSafety_SKMP.vue?vue&type=template&id=08c87af1&scoped=true&"
import script from "./SecSafety_SKMP.vue?vue&type=script&lang=js&"
export * from "./SecSafety_SKMP.vue?vue&type=script&lang=js&"
import style0 from "./SecSafety_SKMP.vue?vue&type=style&index=0&id=08c87af1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c87af1",
  null
  
)

export default component.exports